import React from 'react';
import {translate} from "../../../../../components/translate/translate.jsx";
import ProjectUtils from "../../../../../utils/project-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";
import {getAssetPath} from "../../../../../utils/get-asset-path.js";

const iconPath = getAssetPath("img/alarm_time_line");

const icons = {
    default: `${iconPath}/checked.png`,
    approve: '',
    create:  '',
    delete:  '',
    rectify: '',
    draft:  '',
    file: '',
    invalidate: '',
    reject: '',
    review: '',
    update: ''
};

const actionLabels = {
    "APP.DELETE": "Excluído pelo app",
    "APPROVED": "Aprovado",
    "REJECTED": "Reprovado",
    "REVIEW": "Revisado",
    "CREATE": "Criado",
    "DATA.CREATE": "Criação de dados",
    "DATA.UPDATE": "Corrigido",
    "DATA.RECTIFY": "Retificado",
    "DATA.ADDOTHERDOCUMENT": "Documento adicionado",
    "DRAFT": "Em preenchimento",
    "FILE.CREATE": "Arquivo criado",
    "INVALIDATE": "Invalidado",
};

const sourceLabels = {
    "APP": "APP",
    "UPLOAD_FILE": "Anexo",
    "WEB": "WEB",
};

const relationsLabels = {
    "DISPATCH_RELATION": "Despacho",
    "ENCOUNTER_RELATION": "Abordagem",
};

const groupLabels = {
    "apprehensionList[]": "Apreensão",
    "apprehensionList[].attachs[]": "Anexo da apreensão",
    "companyList[]": "Empresa",
    "companyList[].address": "Endereço da empresa",
    "companyList[].attachs[]": "Anexo da empresa",
    "croqui": "Croqui e fotos",
    "croqui.attachs[]": "Croqui/foto",
    "extraInfo": "Outras informações",
    "gcmReport": "Relatório do agente",
    "individualList[]": "Indivíduo",
    "individualList[].individualVersion[]": "Versão do indivíduo",
    "individualList[].address": "Endereço do indivíduo",
    "individualList[].companyAddress": "Endereço comercial",
    "individualList[].attachs[]": "Anexo do indivíduo",
    "occurrenceData": "Dados da ocorrência",
    "occurrenceData.address": "Endereço da ocorrência",
    "occurrenceData.reason[]": "Natureza",
    "otherDocumentsList[]": "Outro documento",
    "otherDocumentsList[].attachs[]": "Anexos de outro documento",
    "stolenItemList[]": "Item subtraído",
    "stolenItemList[].attachs[]": "Anexo do item subtraído",
    "vehicleList[]": "Veículo",
    "vehicleList[].attachs[]": "Anexo do veículo",
};

const fieldLabels = {
    address: "Logradouro",
    adminPenalty: "Penalidade administrativa",
    alcoholDrugDependency: "Dependência de álcool/drogas",
    apprehended: "Apreendido",
    apprehensionCheckbox: "Apreendido",
    area: "Área",
    brandModel: "Marca/modelo",
    chassis: "Chassi",
    city: "Município",
    cnh: "CNH",
    cnhCategories: "Categoria CNH",
    cnpj: "CNPJ",
    color: "Cor",
    companyName: "Empresa",
    companyPhone: "Telefone comercial",
    complement: "Complemento",
    conditions: "Condições",
    cpf: "CPF",
    criminalRg: "RG criminal",
    description: "Descrição",
    destination: "Destino",
    date: "Data/hora",
    dtBirth: "Data de nascimento",
    dtEnd: "Data/hora final",
    dtFact: "Data/hora do fato",
    dtFactUncertain: "Data do fato incerta",
    dtPlace: "Data/hora no local",
    educationDegree: "Grau de instrução",
    email: "E-mail",
    emitterRg: "Órgão emissor",
    eventName: "Nome do evento",
    eventPersonQuantity: "Quantidade de pessoas no evento",
    extension: "Formato",
    fabricationYear: "Ano de fabricação",
    father: "Pai",
    flagrant: "Flagrante",
    group: "Grupo",
    homeless: "Situação de rua",
    imei: "IMEI",
    injury: "Ferimento/Lesão",
    maritalStatus: "Estado civil",
    medicalExamDueDate: "Validade do exame médico",
    mentalDisorder: "Transtorno mental",
    modelYear: "Ano modelo",
    mother: "Mãe",
    name: "Nome",
    cityOfBirth: "Naturalidade",
    nationality: "Nacionalidade",
    neighborhood: "Bairro",
    nickname: "Apelido",
    nothingToDeclare: "Nada a declarar",
    number: "Número",
    observation: "Observação",
    occupation: "Profissão",
    otherDocument: "Outro documento",
    otherDocumentValue: "Número do documento",
    phone: "Telefone",
    place: "Local pré-cadastrado",
    plate: "Placa",
    quantity: "Quantidade",
    receiver: "Recebedor",
    recovered: "Recuperado",
    referral: "Encaminhamentos",
    relatedPerson: "Pessoa relacionada",
    relatedVehicle: "Veículo relacionado",
    remoteAttach: "Remoto",
    removed: "Removido",
    renavam: "Renavam",
    rg: "RG",
    size: "Tamanho",
    sex: "Sexo",
    socialName: "Nome social",
    subtype: "Subtipo",
    tattoo: "Tatuagem",
    type: "Tipo",
    version: "Versão",
    unit: "Unidade",
    vehicleApprehensionDestiny: "Destino",
    vehicleApprehensionDescription: "Descrição",
    vehicleApprehensionReceiver: "Recebedor",
    value: "Texto",
    zipCode: "CEP",
};

const contextualFieldLabels = {
    "apprehensionList[].attachs[].name": "Anexo",
    "individualList[].color": "Cútis",
    "individualList[].name": "Nome completo",
    "otherDocumentsList[].value": "Número/Nome",
    "gcmReport.value": "Descrição",
    "stolenItemList[].attachs[].name": "Anexo",
    "vehicleList[].city": "Município da placa",
};

const individualSectionFields = {
    address: new Set(["homeless"]),

    general: new Set([
        "nationality",
        "cityOfBirth",
        "maritalStatus",
        "socialName",
        "educationDegree",
        "occupation",
        "color",
        "tattoo",
        "injury",
        "mentalDisorder",
        "alcoholDrugDependency",
    ]),

    documents: new Set([
        "rg",
        "emitterRg",
        "criminalRg",
        "cnh",
        "cnhCategories",
        "medicalExamDueDate",
        "otherDocument",
        "otherDocumentValue",
    ]),

    work: new Set(["companyName", "companyPhone"]),
};

const ignoredDiffGroupPrefixes = new Set();

const timelineGroupOrder = {
    nature: 1,
    occurrence: 2,
    individual: 3,
    company: 4,
    apprehension: 5,
    stolenItem: 6,
    vehicle: 7,
    extraInfo: 8,
    agentReport: 9,
    documents: 10,
    otherDocuments: 11,
    attachment: 12,
    other: 13,
};

const timelineFieldOrder = {
    nature: ["reason", "value", "name", "nameView", "group"],
    occurrence: [
        "dtFact",
        "dtPlace",
        "dtEnd",
        "dtFactUncertain",
        "flagrant",
        "place",
        "address",
        "number",
        "neighborhood",
        "crossroads",
        "referencePoint",
        "city",
        "complement",
        "zipCode",
    ],
    individual: {
        base: ["cpf", "nickname", "name", "conditions", "referral", "dtBirth", "sex", "phone", "email", "mother", "father"],
        general: ["nationality", "cityOfBirth", "maritalStatus", "educationDegree", "occupation", "socialName", "color", "tattoo", "injury", "mentalDisorder", "alcoholDrugDependency"],
        documents: ["rg", "emitterRg", "criminalRg", "cnh", "cnhCategories", "medicalExamDueDate", "otherDocument", "otherDocumentValue"],
        address: ["address", "number", "neighborhood", "city", "complement", "zipCode", "homeless"],
        work: ["companyName", "companyPhone", "address", "number", "neighborhood", "city", "complement", "zipCode"],
        version: ["version", "nothingToDeclare", "signOption", "signatureId"],
        attachment: ["name", "description", "extension", "size", "remoteAttach"],
    },
    company: {
        base: ["name", "cnpj", "email", "phone"],
        address: ["address", "number", "neighborhood", "city", "complement", "zipCode"],
    },
    apprehension: ["relatedPerson", "type", "imei", "subtype", "quantity", "unit", "destination", "receiver", "description", "name", "extension", "size", "remoteAttach"],
    stolenItem: ["relatedPerson", "type", "imei", "subtype", "quantity", "unit", "name", "description", "extension", "size", "remoteAttach"],
    vehicle: [
        "apprehensionCheckbox",
        "relatedPerson",
        "plate",
        "city",
        "renavam",
        "brandModel",
        "type",
        "chassis",
        "fabricationYear",
        "modelYear",
        "color",
        "recovered",
        "removed",
        "observation",
        "vehicleApprehensionDestiny",
        "vehicleApprehensionReceiver",
        "vehicleApprehensionDescription",
    ],
    extraInfo: ["area", "adminPenalty", "eventName", "eventPersonQuantity"],
    agentReport: ["value", "gcmReport", "date", "complement", "signatureId"],
    documents: ["type", "value"],
    otherDocuments: ["type", "value"],
    attachment: ["observation", "description", "name", "extension", "size", "remoteAttach"],
    initialData: ["creationDate", "userName", "data_latitude", "data_longitude", "lastApprovalUserName", "name", "integrants", "animals"],
    default: [],
};

const formattedDateRegex = /^\d{2}\/\d{2}\/\d{4}(\s\d{2}:\d{2}(:\d{2})?)?$/;
const dateFieldKeys = new Set([
    "date",
    "dtBirth",
    "dtEnd",
    "dtFact",
    "dtPlace",
    "medicalExamDueDate",
]);

const preApprovalStatusValues = new Set([
    "NUMBER_GENERATED",
    "PENDING",
    "DRAFT",
    "FILE_SENT",
]);

const postApprovalStatusValues = new Set([
    "INVALIDATED",
    "REJECTED",
    "APPROVED",
    "REVIEWED",
    "APP_DELETED",
    "SYSTEM_DELETED",
]);

const completeStatusValues = new Set([...preApprovalStatusValues, ...postApprovalStatusValues]);
const ignoredFields = new Set([
    'itemId',
    'system_user_id',
    'id',
    'attachId',
    'documentPhotoId'
]);

const actionIcons = {
    "APP.DELETE": icons.delete,
    "APPROVED": icons.approve,
    "REJECTED": icons.reject,
    "REVIEW": icons.review,
    "CREATE": icons.create,
    "DATA.CREATE": icons.file,
    "DATA.UPDATE": icons.update,
    "DATA.RECTIFY": icons.rectify,
    "DRAFT": icons.draft,
    "FILE.CREATE": icons.file,
    "INVALIDATE": icons.invalidate,
};

const hasValue = (value) => {
    if (value === null || value === undefined || value === "") return false;
    if (Array.isArray(value) && value.length === 0) return false;
    return !(typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0);
};

const getActionKey = (action) => String(action ?? "").toUpperCase();

const getStatusAndAction = (value) => {
    const [status, action] = String(value ?? "").split("-").map((item) => item.trim());
    return {status, action};
};

const getStatusValue = (value) => getStatusAndAction(value).status;

const getItemAction = (item) => getStatusAndAction(item.status_value).action ?? item.action;

const ignoreRow = (row) => [row.newValue, row.oldValue, row.fieldKey].some((value) => ignoredFields.has(value));

const getRelation = (item) => item.relations ?? item.relation ?? item.relationship ?? item.relation_name ?? item.bogcm_relation;

const getActionIcon = (action) => actionIcons[getActionKey(action)] ?? icons.default;

const translateAction = (value) => {
    if (!value) return "";
    return actionLabels[getActionKey(value)] ?? value;
};

const translateStatusAndAction = (statusValue, fallbackAction) => {
    const {status, action} = getStatusAndAction(statusValue);
    const translatedStatus = status ? translate(status) : "";
    const translatedAction = translateAction(action ?? fallbackAction);

    if (!translatedAction) return translatedStatus;
    if (!translatedStatus) return translatedAction;

    return `${translatedStatus} - ${translatedAction}`;
};

const translateSource = (value) => {
    if (!value) return "";
    return sourceLabels[value] ?? translate(value);
};

const translateRelation = (value) => {
    const relation = getRelation(value);
    if (!relation) return "";
    return relationsLabels[String(relation).toUpperCase()] ?? relation;
};

const isDateField = (field) => {
    const fieldName = String(field ?? "").replace(/\[\d+]/g, "");
    return dateFieldKeys.has(fieldName) || fieldName.toLowerCase().includes("date") || fieldName.startsWith("dt");
};

const isNumericValue = (value) => {
    if (typeof value === "number") return Number.isFinite(value);
    if (typeof value !== "string") return false;

    return /^-?\d+([.,]\d+)?$/.test(value.trim());
};

const formatDateValue = (value) => {
    if (!hasValue(value)) return "";
    if (typeof value === "string" && formattedDateRegex.test(value)) return value;

    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    return ReportUtils.formatDateTime(date);
};

const parseSerializedObject = (value) => {
    if (typeof value !== "string") return value;

    const trimmedValue = value.trim();
    const isJsonValue = (
        (trimmedValue.startsWith("{") && trimmedValue.endsWith("}")) ||
        (trimmedValue.startsWith("[") && trimmedValue.endsWith("]"))
    );

    if (!isJsonValue) return value;
    return ProjectUtils.safeJsonParse(trimmedValue, value);
};

const parseSerializedValue = (value) => {
    const parsedValue = parseSerializedObject(value);

    if (parsedValue && typeof parsedValue === "object" && !Array.isArray(parsedValue) && Object.hasOwn(parsedValue, "value")) return parsedValue.value;
    return parsedValue;
};

const getLeafFieldName = (value = "") => String(value)
    .replace(/\[\d+]/g, "")
    .replace(/\.\d+(?=\.|$)/g, "")
    .split(".")
    .at(-1);

const formatRelatedPersonValue = (value, individualList = []) => {
    const parsedValue = parseSerializedObject(value);
    if (!hasValue(parsedValue)) return "";

    let itemId;
    let name;

    if (typeof parsedValue === "object" && !Array.isArray(parsedValue)) {
        itemId = parsedValue.itemId ?? parsedValue.id ?? parsedValue.value;
        name = parsedValue.name ?? parsedValue.label ?? parsedValue.text;
    } else {
        const text = String(parsedValue).trim();
        const invertedNamedValueMatch = text.match(/^Indivíduo\s+-\s+(.+)$/i);
        const namedValueMatch = text.match(/^(.+?)\s+-\s+(.+)$/);

        if (invertedNamedValueMatch) {
            itemId = invertedNamedValueMatch[1];
        } else if (namedValueMatch) {
            itemId = namedValueMatch[1];
            name = namedValueMatch[2];
        } else {
            itemId = text;
        }
    }

    if (hasValue(itemId)) {
        const individual = (Array.isArray(individualList) ? individualList : []).find((currentIndividual) => (String(currentIndividual?.itemId) === String(itemId)));
        const resolvedName = name ?? individual?.name;
        const hasPersonName = hasValue(resolvedName) && !/^indivíduo(?:\s+-\s+.+)?$/i.test(String(resolvedName).trim());

        return hasPersonName ? `${itemId} - ${resolvedName}` : `Indivíduo - ${itemId}`;
    }

    return typeof parsedValue === "object" ? Object.values(parsedValue).filter(hasValue).join(" - ") : String(parsedValue).trim();
};

const formatValue = (value, field, individualList = []) => {
    if (getLeafFieldName(field) === "relatedPerson") return formatRelatedPersonValue(value, individualList);

    const parsedValue = parseSerializedValue(value);
    if (parsedValue !== value) return formatValue(parsedValue, field, individualList);

    if (!hasValue(value)) return "";
    if (typeof value === "boolean") return value ? "Sim" : "Não";
    if (String(value).toLowerCase() === "true") return "Sim";
    if (String(value).toLowerCase() === "false") return "Não";

    if (isDateField(field)) return formatDateValue(value);
    if (Array.isArray(value)) return value.map((item) => formatValue(item, field, individualList)).filter(Boolean).join(", ");
    if (typeof value === "object") return Object.values(value).map((item) => formatValue(item, field, individualList)).filter(Boolean).join(", ");
    if (isNumericValue(value)) return String(value);
    return translate(String(value));
};

const getEvaluatedBy = (item) => item.evaluation_namewar ?? item.evaluator_namewar ?? item.validation_namewar;

const isDiffValue = (value) => {
    return value && typeof value === "object" && !Array.isArray(value) && (Object.hasOwn(value, "new") || Object.hasOwn(value, "old"));
};

const normalizeLabelPath = (value = "") => String(value)
    .replace(/\[\d+]/g, "[]")
    .replace(/\.\d+(?=\.|$)/g, "[]");

const getListNumber = (value = "") => {
    const match = String(value).match(/\[(\d+)]|(?:^|\.)(\d+)(?=\.|$)/);
    if (!match) return "";
    return ` ${Number(match[1] ?? match[2]) + 1}`;
};

const getListIndex = (value = "") => {
    const match = String(value).match(/\[(\d+)]|(?:^|\.)(\d+)(?=\.|$)/);
    if (!match) return Number.MAX_SAFE_INTEGER;
    return Number(match[1] ?? match[2]);
};

const translateField = (value) => {
    const cleanValue = getLeafFieldName(value);
    return fieldLabels[cleanValue] ?? translate(cleanValue);
};

const getGroupTitle = (label, fallbackIndex) => {
    const normalizedLabel = normalizeLabelPath(label);
    const groupLabel = groupLabels[normalizedLabel] ?? translate(label);
    const number = getListNumber(label);

    if (number && normalizedLabel === "individualList[].address") return `Indivíduo${number} - Endereço`;

    if (number && normalizedLabel === "individualList[].companyAddress") return `Indivíduo${number} - Trabalho`;

    if (number && normalizedLabel === "companyList[].address") return `Empresa${number} - Endereço`;

    if (number) return `${groupLabel}${number}`;
    return groupLabel || `Alteração ${fallbackIndex + 1}`;
};

const getContextualFieldLabel = (field, context, fieldPath) => {
    const normalizedField = normalizeLabelPath(field);
    const normalizedContext = normalizeLabelPath(context);
    const normalizedFieldPath = normalizeLabelPath(fieldPath);
    const candidatePaths = [
        normalizedFieldPath,
        normalizedContext && `${normalizedContext}.${normalizedField}`,
        normalizedField,
        normalizedContext,
    ].filter(Boolean);

    return candidatePaths
        .map((path) => contextualFieldLabels[path])
        .find(Boolean);
};

const getFieldLabel = (field, context, fieldPath) => {
    const contextualLabel = getContextualFieldLabel(field, context, fieldPath);
    if (contextualLabel) return contextualLabel;
    if (!field || field === "value") return fieldLabels.value;
    return translateField(field);
};

const isIgnoredDiffPath = (path) => {
    const normalizedPath = normalizeLabelPath(path);
    return [...ignoredDiffGroupPrefixes].some((prefix) => (
        normalizedPath === prefix || normalizedPath.startsWith(`${prefix}.`) || normalizedPath.startsWith(`${prefix}[]`)
    ));
};

const buildDiffRowsFromValue = (field, value, context = field, fieldPath = field) => {
    if (isIgnoredDiffPath(fieldPath)) return [];

    if (isDiffValue(value)) {
        return [{
            field: getFieldLabel(field, context, fieldPath),
            fieldKey: field,
            fieldPath,
            context,
            newValue: value.new,
            oldValue: value.old,
        }];
    }

    if (!value || typeof value !== "object" || Array.isArray(value) || getLeafFieldName(field) === "relatedPerson") {
        return [{
            field: getFieldLabel(field, context, fieldPath),
            fieldKey: field,
            fieldPath,
            context,
            newValue: value,
            oldValue: undefined,
        }];
    }

    return Object.entries(value)
        .filter(([currentField]) => currentField !== "label")
        .flatMap(([currentField, currentValue]) => buildDiffRowsFromValue(
            currentField,
            currentValue,
            context,
            `${fieldPath}.${currentField}`
        ));
};

const getIndividualRootLabel = (value = "") => {
    const source = String(value);
    const match = source.match(/individualList(?:\[(\d+)]|\.(\d+))/);
    if (match) return `individualList[${match[1] ?? match[2]}]`;
    if (normalizeLabelPath(source).startsWith("individualList[]")) return "individualList[]";
    return "";
};

const getIndividualSection = (row) => {
    const context = normalizeLabelPath(row.context);
    const fieldPath = normalizeLabelPath(row.fieldPath);
    const field = String(row.fieldKey ?? "")
        .replace(/\[\d+]/g, "")
        .split(".")
        .at(-1);

    if (context.includes(".individualVersion") || fieldPath.includes(".individualVersion")) return "version";
    if (context.includes(".attachs") || fieldPath.includes(".attachs")) return "attachment";
    if (individualSectionFields.address.has(field)) return "address";
    if (context.endsWith(".address") || fieldPath.endsWith(".address") || fieldPath.includes(".address.")) return "address";

    if (context.endsWith(".companyAddress") || fieldPath.endsWith(".companyAddress") || fieldPath.includes(".companyAddress.") || individualSectionFields.work.has(field)) {
        return "work";
    }

    if (individualSectionFields.documents.has(field)) return "documents";
    if (individualSectionFields.general.has(field)) return "general";

    return "base";
};

const getIndividualSectionTitle = (section, individualLabel) => {
    const number = getListNumber(individualLabel);

    if (section === "general" && number) return `Indivíduo${number} - Informações Gerais`;
    if (section === "documents" && number) return `Indivíduo${number} - Documentos`;
    if (section === "address" && number) return `Indivíduo${number} - Endereço`;
    if (section === "work" && number) return `Indivíduo${number} - Trabalho`;
    if (section === "version") return getGroupTitle(`${individualLabel}.individualVersion[]`, 0);
    if (section === "attachment") return getGroupTitle(`${individualLabel}.attachs[]`, 0);

    return {
        general: "Informações Gerais",
        documents: "Documentos",
        address: "Endereço",
        work: "Trabalho",
    }[section] ?? getGroupTitle(individualLabel, 0);
};

const splitIndividualDiffGroup = (group) => {
    const normalizedLabel = normalizeLabelPath(group.label);
    const hasIndividualRows = group.rows.some((row) => getIndividualRootLabel(row.context ?? row.fieldPath));
    const shouldSplit = normalizedLabel === "individualList[]" || (!group.label && hasIndividualRows);

    if (!shouldSplit) return [group];

    const sections = new Map();

    group.rows.forEach((row) => {
        const individualLabel = getIndividualRootLabel(row.context ?? row.fieldPath);
        const section = getIndividualSection(row);
        const key = `${individualLabel || "other"}|${section}`;

        if (!sections.has(key)) {
            sections.set(key, {
                ...group,
                label: individualLabel || group.label,
                sectionKey: section,
                title: section === "base" ? (individualLabel ? getGroupTitle(individualLabel, 0) : group.title) : getIndividualSectionTitle(section, individualLabel || group.label),
                rows: [],
            });
        }

        sections.get(key).rows.push(row);
    });

    const sectionOrder = ["base", "general", "documents", "address", "work", "version", "attachment"];
    return [...sections.values()].sort((first, second) => {
        const firstSection = getIndividualSection(first.rows[0]);
        const secondSection = getIndividualSection(second.rows[0]);
        return sectionOrder.indexOf(firstSection) - sectionOrder.indexOf(secondSection);
    });
};

const canonicalizeDiffPath = (value = "") => String(value)
    .replace(/\.(\d+)(?=\.|$)/g, "[$1]");

const getGroupSourcePath = (group) => group.label || group.rows?.[0]?.context || group.rows?.[0]?.fieldPath || "";

const getGroupSectionKey = (group) => {
    if (group.sectionKey) return group.sectionKey;

    const individualRow = group.rows?.find((row) => getIndividualRootLabel(row.context ?? row.fieldPath));
    return individualRow ? getIndividualSection(individualRow) : "";
};

const isAttachmentPath = (value = "") => {
    const normalizedPath = normalizeLabelPath(value);
    return normalizedPath === "croqui" || normalizedPath.startsWith("croqui.") || normalizedPath.includes(".attachs");
};

const isStolenItemAttachmentPath = (value = "") => normalizeLabelPath(value).startsWith("stolenItemList[].attachs");

const isApprehensionAttachmentPath = (value = "") => normalizeLabelPath(value).startsWith("apprehensionList[].attachs");

const isMergedCollectionAttachmentPath = (value = "") => (
    isApprehensionAttachmentPath(value) || isStolenItemAttachmentPath(value)
);

const getCollectionRootLabel = (value = "") => {
    const source = canonicalizeDiffPath(value);
    const match = source.match(/^(companyList|apprehensionList|stolenItemList|vehicleList|otherDocumentsList)(?:\[(\d+)]|\.(\d+))/);

    if (match) return `${match[1]}[${match[2] ?? match[3]}]`;

    const collection = ["companyList", "apprehensionList", "stolenItemList", "vehicleList", "otherDocumentsList"]
        .find((currentCollection) => normalizeLabelPath(source).startsWith(`${currentCollection}[]`));

    return collection ? `${collection}[]` : "";
};

const getCollectionSection = (group, sourcePath) => {
    const normalizedPath = normalizeLabelPath(sourcePath);
    if (getGroupSectionKey(group) === "attachment" || isAttachmentPath(sourcePath)) return "attachment";
    if (normalizedPath.includes("companyList[].address")) return "address";
    return "base";
};

const getNatureRootLabel = (value = "") => {
    const source = canonicalizeDiffPath(value);
    const match = source.match(/^occurrenceData\.reason(?:\[(\d+)]|\.(\d+))/);

    if (match) return `occurrenceData.reason[${match[1] ?? match[2]}]`;
    if (normalizeLabelPath(source).startsWith("occurrenceData.reason[]")) return "occurrenceData.reason[]";
    return "";
};

const getGroupMergeKey = (group) => {
    const sourcePath = getGroupSourcePath(group);
    const individualRoot = getIndividualRootLabel(sourcePath);

    if (individualRoot) {
        return `individual:${canonicalizeDiffPath(individualRoot)}:${getGroupSectionKey(group) || "base"}`;
    }

    const collectionRoot = getCollectionRootLabel(sourcePath);
    if (collectionRoot) {
        const section = getCollectionSection(group, sourcePath);
        const mergeSection = isMergedCollectionAttachmentPath(sourcePath) ? "base" : section;
        const suffix = collectionRoot.endsWith("[]") ? `:${group.sourceIndex ?? 0}` : "";
        return `collection:${canonicalizeDiffPath(collectionRoot)}:${mergeSection}${suffix}`;
    }

    const natureRoot = getNatureRootLabel(sourcePath);
    if (natureRoot) {
        const suffix = natureRoot.endsWith("[]") ? `:${group.sourceIndex ?? 0}` : "";
        return `nature:${canonicalizeDiffPath(natureRoot)}${suffix}`;
    }

    return `group:${canonicalizeDiffPath(sourcePath) || group.title || group.sourceIndex}`;
};

const mergeDiffGroups = (groups) => {
    const mergedGroups = new Map();

    groups.forEach((group, index) => {
        const mergeKey = getGroupMergeKey({...group, sourceIndex: group.sourceIndex ?? index});
        const existingGroup = mergedGroups.get(mergeKey);

        if (existingGroup) {
            existingGroup.rows.push(...group.rows);
            return;
        }

        mergedGroups.set(mergeKey, {
            ...group,
            sourceIndex: group.sourceIndex ?? index,
            rows: [...group.rows],
        });
    });

    return [...mergedGroups.values()];
};

const getGroupCategory = (group) => {
    const sourcePath = getGroupSourcePath(group);
    const normalizedPath = normalizeLabelPath(sourcePath);
    const section = getGroupSectionKey(group);

    if (isApprehensionAttachmentPath(sourcePath)) return "apprehension";
    if (isStolenItemAttachmentPath(sourcePath)) return "stolenItem";
    if (section === "attachment" || isAttachmentPath(sourcePath)) return "attachment";
    if (normalizedPath === "occurrenceData.reason[]" || normalizedPath.startsWith("occurrenceData.reason[].")) return "nature";
    if (normalizedPath === "occurrenceData" || normalizedPath.startsWith("occurrenceData.")) return "occurrence";
    if (normalizedPath === "individualList[]" || normalizedPath.startsWith("individualList[].")) return "individual";
    if (normalizedPath === "companyList[]" || normalizedPath.startsWith("companyList[].")) return "company";
    if (normalizedPath === "apprehensionList[]" || normalizedPath.startsWith("apprehensionList[].")) return "apprehension";
    if (normalizedPath === "stolenItemList[]" || normalizedPath.startsWith("stolenItemList[].")) return "stolenItem";
    if (normalizedPath === "vehicleList[]" || normalizedPath.startsWith("vehicleList[].")) return "vehicle";
    if (normalizedPath === "extraInfo" || normalizedPath.startsWith("extraInfo.")) return "extraInfo";
    if (normalizedPath === "gcmReport" || normalizedPath.startsWith("gcmReport.") || normalizedPath === "gcmReportComplementList[]" ||
        normalizedPath.startsWith("gcmReportComplementList[].") || normalizedPath === "gcmReportSignature" || normalizedPath.startsWith("gcmReportSignature.")
    ) return "agentReport";
    if (normalizedPath === "documents" || normalizedPath.startsWith("documents.")) return "documents";
    if (normalizedPath === "otherDocumentsList[]" || normalizedPath.startsWith("otherDocumentsList[].")) return "otherDocuments";

    return "other";
};

const getRowFieldName = (row) => getLeafFieldName(row.fieldPath || row.fieldKey);

const getGroupFieldOrder = (group, row) => {
    const category = getGroupCategory(group);

    if (category === "individual") return timelineFieldOrder.individual[getIndividualSection(row)] ?? timelineFieldOrder.default;

    if (category === "company") {
        const section = getCollectionSection(group, getGroupSourcePath(group));
        return timelineFieldOrder.company[section] ?? timelineFieldOrder.company.base;
    }

    if (category === "other" && normalizeLabelPath(getGroupSourcePath(group)).startsWith("initialData")) return timelineFieldOrder.initialData;

    return timelineFieldOrder[category] ?? timelineFieldOrder.default;
};

const orderDiffRows = (group) => {
    const rows = group.rows
        .map((row, index) => {
            const fieldOrder = getGroupFieldOrder(group, row);
            const fieldIndex = fieldOrder.indexOf(getRowFieldName(row));

            return {
                row,
                fieldIndex: fieldIndex < 0 ? fieldOrder.length : fieldIndex,
                index,
            };
        })
        .sort((first, second) => first.fieldIndex - second.fieldIndex || first.index - second.index)
        .map(({row}) => row);

    return {
        ...group,
        rows,
    };
};

const individualSectionOrder = ["base", "general", "documents", "address", "work", "version", "attachment"];
const groupSectionOrder = ["base", "address", "work"];

const getGroupSortValues = (group, index) => {
    const category = getGroupCategory(group);
    const sourcePath = getGroupSourcePath(group);
    const section = getGroupSectionKey(group);
    const listIndex = getListIndex(sourcePath);
    const sectionOrder = category === "individual" ? individualSectionOrder : groupSectionOrder;
    const sectionIndex = sectionOrder.indexOf(section || "base");

    return {
        categoryIndex: timelineGroupOrder[category] ?? timelineGroupOrder.other,
        listIndex,
        sectionIndex: sectionIndex < 0 ? sectionOrder.length : sectionIndex,
        index,
    };
};

const getGroupTitleForCategory = (group, fallbackIndex) => {
    const sourcePath = getGroupSourcePath(group);
    const individualRoot = getIndividualRootLabel(sourcePath);

    if (individualRoot) {
        const section = getGroupSectionKey(group);
        if (section === "base") return getGroupTitle(individualRoot, fallbackIndex);
        return getIndividualSectionTitle(section, individualRoot);
    }

    const collectionRoot = getCollectionRootLabel(sourcePath);
    if (collectionRoot && getCollectionSection(group, sourcePath) === "address") {
        return getGroupTitle(`${collectionRoot}.address`, fallbackIndex);
    }

    if (collectionRoot && (getCollectionSection(group, sourcePath) === "base" || isMergedCollectionAttachmentPath(sourcePath))) {
        return getGroupTitle(collectionRoot, fallbackIndex);
    }

    return group.title;
};

const orderDiffGroups = (groups) => {
    const orderedGroups = groups
        .map((group, index) => {
            const orderedGroup = orderDiffRows(group);

            return {
                ...orderedGroup,
                title: getGroupTitleForCategory(orderedGroup, index),
                sourceIndex: group.sourceIndex ?? index,
                sortValues: getGroupSortValues(orderedGroup, index),
            };
        })
        .sort((first, second) => {
            const firstValues = first.sortValues;
            const secondValues = second.sortValues;

            return firstValues.categoryIndex - secondValues.categoryIndex ||
                firstValues.listIndex - secondValues.listIndex ||
                firstValues.sectionIndex - secondValues.sectionIndex ||
                firstValues.index - secondValues.index;
        });

    let natureIndex = 0;

    return orderedGroups.map((group) => {
        if (getGroupCategory(group) !== "nature") return group;

        natureIndex += 1;
        return {
            ...group,
            title: `Natureza ${natureIndex}`,
        };
    }).map(({sortValues, ...group}) => group);
};

const buildDiffGroups = (item) => {
    const diff = ProjectUtils.safeJsonParse(item?.diff, []);

    if (Array.isArray(diff)) {
        const groups = diff
            .filter((entry) => !isIgnoredDiffPath(entry?.label))
            .map((entry, index) => {
                const label = entry?.label ?? `Alteração ${index + 1}`;
                const rows = buildDiffRowsFromValue(label, entry)
                    .filter((row) => hasValue(row.newValue) || hasValue(row.oldValue));

                return {
                    title: getGroupTitle(label, index),
                    label,
                    sourceIndex: index,
                    rows,
                };
            })
            .filter((group) => group.rows.length)
            .flatMap(splitIndividualDiffGroup);

        return orderDiffGroups(mergeDiffGroups(groups));
    }

    if (!diff || typeof diff !== "object") return [];

    const rows = Object.entries(diff)
        .filter(([field]) => !isIgnoredDiffPath(field))
        .flatMap(([field, value]) => buildDiffRowsFromValue(field, value))
        .filter((row) => hasValue(row.newValue) || hasValue(row.oldValue));

    if (!rows.length) return [];

    const groups = splitIndividualDiffGroup({
        title: "Alteração 1",
        rows,
    });

    return orderDiffGroups(mergeDiffGroups(groups));
};

const buildObservationRows = (item) => {
    const rows = [
        {
            field: "Motivo",
            value: item.rejected_justification,
        },
        {
            field: "Observação",
            value: item.status_observation,
        },
    ];

    return rows.filter((row) => hasValue(row.value));
};

const renderDetail = (label, value) => {
    if (!hasValue(value)) return null;

    return (
        <span className={'text-zinc-500'}>
            {label}: <strong>{label === 'Agente' ? ReportUtils.formatText(value) : value}</strong>
        </span>
    );
};

const renderDiffTable = (rows, showDiff, individualList = []) => {
    if (!rows.length) return null;

    if (!showDiff) {
        return (
            <table className="w-full border-t border-zinc-200 text-left text-[13px] font-normal text-zinc-500">
                <thead>
                    <tr>
                        <th className="w-[30%] py-2 pr-4 font-semibold text-zinc-600">Campo</th>
                        <th className="py-2 font-semibold text-zinc-600">Texto</th>
                    </tr>
                </thead>
                <tbody>
                    { rows.map((row, rowIndex) => {
                        if (ignoreRow(row)) return null;

                        return (
                            <tr key={`${row.fieldPath ?? row.fieldKey ?? row.field}-${rowIndex}`}>
                                <td className="py-1 pr-4 align-top font-semibold text-zinc-500">{row.field}</td>
                                <td className="py-1 align-top font-semibold text-zinc-500">{formatValue(row.newValue ?? row.oldValue, row.fieldKey, individualList)}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        );
    }

    return (
        <table className="w-full border-t border-zinc-200 text-left text-[13px] font-normal text-zinc-500">
            <thead>
                <tr>
                    <th className="w-[30%] py-2 pr-4 font-semibold text-zinc-600">Campo</th>
                    <th className="w-[35%] py-2 pr-4 font-semibold text-zinc-600">Novo</th>
                    <th className="w-[35%] py-2 font-semibold text-zinc-600">Antigo</th>
                </tr>
            </thead>
            <tbody>
                { rows.map((row, rowIndex) => {
                    if (ignoreRow(row)) return null;

                    return (
                        <tr key={`${row.fieldPath ?? row.fieldKey ?? row.field}-${rowIndex}`}>
                            <td className="py-1 pr-4 align-top font-semibold text-zinc-500">{row.field}</td>
                            <td className="py-1 pr-4 align-top font-semibold text-zinc-500">{formatValue(row.newValue, row.fieldKey, individualList)}</td>
                            <td className="py-1 align-top font-semibold text-zinc-500">{formatValue(row.oldValue, row.fieldKey, individualList)}</td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    );
};

const renderDiffGroups = (groups, showDiff, individualList = []) => {
    if (!groups.length || !showDiff) return null;

    return (
        <div className="space-y-4">
            { groups.map((group, index) => (
                <div key={`${group.title}-${index}`} className="space-y-1">
                    <div className="text-sm font-semibold text-zinc-500 print:break-after-avoid!">
                        {group.title === 'rectification' ? "Retificação" : group.title === 'garrison' ? "Guarnição" : group.title}
                    </div>

                    {renderDiffTable(group.rows, showDiff, individualList)}
                </div>
            ))}
        </div>
    );
};

const renderObservationTable = (rows) => {
    if (!rows.length) return null;

    return (
        <div className="mt-1 border-t border-zinc-200 pt-2 flex flex-wrap gap-x-4 gap-y-1 text-[13px] font-normal text-zinc-500">
            { rows.map((row) => (
                <React.Fragment key={row.field}>
                    {renderDetail(row.field, row.value)}
                </React.Fragment>
            ))}
        </div>
    );
};

const getCompleteTitle = (item, isPreApprovalStatus) => {
    if (!isPreApprovalStatus) {
        const action = getItemAction(item);
        if (action) return translateAction(action);

        return translateStatusAndAction(item.status_value, item.action);
    }

    return translateStatusAndAction(item.status_value, item.action);
};

const buildCompleteContent = (item, index, printOptions, individualList = []) => {
    const diffGroups = buildDiffGroups(item);
    const isPreApprovalStatus = preApprovalStatusValues.has(getStatusValue(item.status_value));
    const showResponsible = !!printOptions?.showResponsible;
    const showDiff = !!printOptions?.showDiff;
    const observationRows = isPreApprovalStatus ? [] : buildObservationRows(item);
    const sourceLabel = translateSource(item.generated_source);
    const evaluatedBy = isPreApprovalStatus ? getEvaluatedBy(item) : item.validation_namewar;

    return (
        <div className="space-y-3" key={`complete-content-${index}`}>
            <div>
                <div className="text-base font-semibold text-zinc-500 print:break-after-avoid!">
                    {getCompleteTitle(item, isPreApprovalStatus)}
                </div>

                <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-[13px] font-normal text-zinc-500">
                    {renderDetail("Relação", translateRelation(item))}
                    {showResponsible && renderDetail("Agente", evaluatedBy)}
                </div>
            </div>

            {renderDiffGroups(diffGroups, showDiff, individualList)}
            {renderObservationTable(observationRows)}
        </div>
    );
};

export const buildCompleteTimelineItems = (data = [], printOptions, individualList = []) => {
    return [...(data ?? [])]
        .filter((item) => completeStatusValues.has(getStatusValue(item.status_value)))
        .map((item, index) => ({
            dt: item.time_action,
            status: item.status_value,
            icon: getActionIcon(getStatusValue(item?.status_value)),
            text: buildCompleteContent(item, index, printOptions, individualList),
            removeIcon: true
        }));
};